import {
    GET_EVENT,
} from '../actions/EventActions'
import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'event',
    storage,
};


const initialState = {
    data: [],
    allEvents: [],
    latestUpdate: '',
    loading: false,
    error: '',

    event: null
}

const EventReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_EVENT: {
            return {
                ...state,
                event: action.payload,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, EventReducer);

